import { Navigate, Route, Routes } from "react-router-dom";
import NameMailPage from "./app/(auth)/name_edit/page";
import UserLoginPage from "./app/(auth)/login/page";
import AdminLoginPage from "./app/(auth)/login/admin/page";
import AdminRegisterPage from "./app/(auth)/register/admin/page";
import VerifyOtpPage from "./app/(auth)/verify-otp/page";
import LandingPage from "./app/(public)/landing/LandingPage";
// Layouts
import UserLayout from "./app/user/layout";
import SuperAdminLayout from "./app/superadmin/layout";
import AdminLayout from "./app/admin/layout";

// User pages
import UserProfilePage from "./app/user/profile/page";
import UserGroup from "./app/user/my-groups/page";

// SuperAdmin pages
import SuperAdminChannelsPage from "./app/superadmin/channels/page";
import SuperAdminOverviewPage from "./app/superadmin/overview/page";
import SuperAdminPlansPage from "./app/superadmin/plans/page";
import SuperAdminSubscriptionsPage from "./app/superadmin/subscriptions/page";
import SuperAdminUsersPage from "./app/superadmin/users/page";
import SuperAdminTeamsPage from "./app/superadmin/teams/page"
import SuperAdminForgotpassPage from "./app/superadmin/teams/forgot/page";
import SuperAdminIntegrationsPage from "./app/superadmin/integrations/page";
import SuperAdminRolesPage from "./app/superadmin/roles/page";

// Admin pages
import AdminChannelsPage from "./app/admin/channels/page";
import AdminChannelNewPage from "./app/admin/channels/new/page";
import AdminProfilePage from "./app/admin/profile/page";
import AdminMyTeamPage from "./app/admin/my-team/page";
import AdminOverview from "./app/admin/overview/page";
import AdminChannelEdit from "./app/admin/channels/[id]/edit/page";
import AdminChannelsubscriptions from "./app/admin/channels/[id]/subscriptions/page";
import AdminChannelplans from "./app/admin/channels/[id]/plans/page";
import AdminChanneloverview from "./app/admin/channels/[id]/overview/page";
import AdminPlanNew from "./app/admin/plans/new/page";
import AdminPlanEdit from "./app/admin/plans/[planId]/edit/page";
import AdminComboPlansPage from "./app/admin/combo/page";
import AdminComboPlansEditPage from "./app/admin/combo/[id]/edit/page";
import AdminManualAddUserPage from "./app/admin/manual-add/page";
import AdminCouponPage from "./app/admin/coupons/page";
import AdminSettingsPage from "./app/admin/settings/page";
import PublicChannelPage from "./app/(public)/page";
import AdminLeasdsPage from "./app/admin/leads/page"
import PublicComboPage from "./app/(public)/combo/page";
import TermsOfServicePage from "./app/(public)/terms/page";
import PrivacyPolicyPage from "./app/(public)/privacy/page";
import SupportPage from "./app/(public)/support/page";
import AdminComboOverviewStub from "./app/admin/combo/[id]/overview/index";
import AdminComboSubscriptionsStub from "./app/admin/combo/[id]/subscriptions/index";
const Navs = () => {
    return (
        <Routes>
            {/* Public routes */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/home" element={<LandingPage />} />
            <Route path="/login" element={<UserLoginPage />} />
            <Route path="/login/admin" element={<AdminLoginPage />} />
            <Route path="/register/admin" element={<AdminRegisterPage />} />
            <Route path="/register" element={<Navigate to="/login" replace />} />
            <Route path="/nameMail" element={<NameMailPage />} />
            <Route path="/verify-otp" element={<VerifyOtpPage />} />

            {/* User routes */}
            <Route path="/user" element={<UserLayout />}>
                <Route path="profile" element={<UserProfilePage />} />
                <Route path="my-groups" element={<UserGroup />} />
            </Route>

            {/* SuperAdmin routes */}
            <Route path="/superadmin" element={<SuperAdminLayout />}>
                <Route path="channels" element={<SuperAdminChannelsPage />} />
                <Route path="overview" element={<SuperAdminOverviewPage />} />
                <Route path="plans" element={<SuperAdminPlansPage />} />
                <Route path="subscriptions" element={<SuperAdminSubscriptionsPage />} />
                <Route path="users" element={<SuperAdminUsersPage />} />
                <Route path="teams" element={<SuperAdminTeamsPage />} />
                <Route path="forgot" element={<SuperAdminForgotpassPage />} />
                <Route path="integrations" element={<SuperAdminIntegrationsPage />} />
                <Route path="roles" element={<SuperAdminRolesPage />} />
            </Route>

            {/* Admin routes */}
            <Route path="/admin" element={<AdminLayout />}>
                <Route path="overview" element={<AdminOverview />} />
                <Route path="channels" element={<AdminChannelsPage />} />
                <Route path="channels/new" element={<AdminChannelNewPage />} />
                <Route path="leads" element={<AdminLeasdsPage />} />
                <Route path="combo" element={<AdminComboPlansPage />} />
                <Route path="combo/:id/edit" element={<AdminComboPlansEditPage />} />
                <Route path="combo/:id/overview" element={<AdminComboOverviewStub />} />
                <Route path="combo/:id/subscriptions" element={<AdminComboSubscriptionsStub />} />
                <Route path="channels/:id/edit" element={<AdminChannelEdit />} />
                <Route path="channels/:id/subscriptions" element={<AdminChannelsubscriptions />} />
                <Route path="channels/:id/plans" element={<AdminChannelplans />} />
                <Route path="channels/:id/overview" element={<AdminChanneloverview />} />
                <Route path="profile" element={<AdminProfilePage />} />
                <Route path="my-team" element={<AdminMyTeamPage />} />
                <Route path="plans/new" element={<AdminPlanNew />} />
                <Route path="plans/:planId/edit" element={<AdminPlanEdit />} />
                <Route path="manual-add" element={<AdminManualAddUserPage />} />
                <Route path="coupons" element={<AdminCouponPage />} />
                <Route path="settings" element={<AdminSettingsPage />} />
            </Route>
            <Route path="/channel/:referralCode" element={<PublicChannelPage />} />
            <Route path="/combo/:referralCode" element={<PublicComboPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/support" element={<SupportPage />} />

            {/* Fallback for undefined routes */}
            <Route path="*" element={<UserLoginPage />} />
        </Routes>
    );
};

export default Navs;
